import { useEffect, useState } from "react";
import { IExpenseVendor } from "../models/IExpenseVendor";
import {
  createExpenseVendor,
  deleteExpenseVendor,
  getExpenseVendors,
  updateExpenseVendor,
} from "../services/expenseVendor";

const EMPTY_FORM = { name: "", note: "" };

interface Props {
  onClose: () => void;
  onChange?: () => void;
}

/* ── Firma kartı ── */
function VendorCard({
  vendor, onSaved, onDeleted,
}: {
  vendor: IExpenseVendor;
  onSaved: () => void;
  onDeleted: () => void;
}) {
  const [editing, setEditing] = useState(false);
  const [name, setName] = useState(vendor.name);
  const [note, setNote] = useState(vendor.note);
  const [isEnabled, setIsEnabled] = useState(vendor.isEnabled);
  const [saving, setSaving] = useState(false);
  const [saveError, setSaveError] = useState<string | null>(null);
  const [confirmDel, setConfirmDel] = useState(false);
  const [deleting, setDeleting] = useState(false);

  const inp: React.CSSProperties = { width: "100%", borderRadius: 9, border: "1.5px solid #fde68a", padding: "8px 12px", fontSize: "0.86rem", color: "#111827", outline: "none", background: "#fff", fontFamily: "inherit", boxSizing: "border-box" };

  const handleSave = async () => {
    if (!name.trim()) { setSaveError("Firma adı zorunludur."); return; }
    setSaving(true);
    setSaveError(null);
    try {
      await updateExpenseVendor(vendor.id, { name: name.trim(), note: note.trim(), isEnabled });
      setEditing(false);
      onSaved();
    } catch {
      setSaveError("Güncellenemedi. Lütfen tekrar deneyin.");
    } finally {
      setSaving(false);
    }
  };

  const handleDelete = async () => {
    setDeleting(true);
    try {
      await deleteExpenseVendor(vendor.id);
      onDeleted();
    } catch {
      setDeleting(false);
      setConfirmDel(false);
    }
  };

  if (editing) {
    return (
      <div style={{ border: "1.5px solid #fde68a", borderRadius: 14, background: "#fffbeb", padding: "12px 14px", display: "flex", flexDirection: "column", gap: 8 }}>
        <input value={name} onChange={(e) => setName(e.target.value)} placeholder="Firma adı" style={inp} />
        <input value={note} onChange={(e) => setNote(e.target.value)} placeholder="Not (opsiyonel)" style={inp} />
        <label style={{ display: "flex", alignItems: "center", gap: 8, fontSize: "0.8rem", color: "#92400e", fontWeight: 600, cursor: "pointer" }}>
          <input type="checkbox" checked={isEnabled} onChange={(e) => setIsEnabled(e.target.checked)} />
          Aktif
        </label>
        {saveError && <div style={{ fontSize: "0.76rem", color: "#dc2626" }}>{saveError}</div>}
        <div style={{ display: "flex", gap: 8 }}>
          <button onClick={handleSave} disabled={saving}
            style={{ flex: 1, background: "linear-gradient(135deg,#b45309,#d97706)", border: "none", borderRadius: 8, padding: "7px 0", fontWeight: 700, fontSize: "0.8rem", color: "#fff", cursor: saving ? "default" : "pointer", display: "flex", alignItems: "center", justifyContent: "center", gap: 6 }}>
            {saving ? <span className="spinner-border spinner-border-sm" /> : <><i className="bi bi-check-lg" /> Kaydet</>}
          </button>
          <button onClick={() => setEditing(false)} disabled={saving}
            style={{ flex: 1, background: "#fff", border: "1.5px solid #e5e7eb", borderRadius: 8, padding: "7px 0", fontWeight: 700, fontSize: "0.8rem", color: "#374151", cursor: "pointer" }}>
            Vazgeç
          </button>
        </div>
      </div>
    );
  }

  return (
    <div style={{ border: "1.5px solid #e5e7eb", borderRadius: 14, background: vendor.isEnabled ? "#fff" : "#f9fafb", padding: "12px 14px" }}>
      <div style={{ display: "flex", alignItems: "flex-start", gap: 10 }}>
        <div style={{
          width: 38, height: 38, borderRadius: 10, flexShrink: 0,
          background: vendor.isEnabled ? "linear-gradient(135deg,#b45309,#d97706)" : "linear-gradient(135deg,#9ca3af,#6b7280)",
          display: "flex", alignItems: "center", justifyContent: "center",
        }}>
          <i className="bi bi-building text-white" style={{ fontSize: "0.95rem" }} />
        </div>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ fontWeight: 700, fontSize: "0.9rem", color: "#111827", display: "flex", alignItems: "center", gap: 6, flexWrap: "wrap" }}>
            {vendor.name}
            <span style={{
              fontSize: "0.6rem", fontWeight: 700,
              background: vendor.isEnabled ? "#dcfce7" : "#f3f4f6",
              color: vendor.isEnabled ? "#16a34a" : "#9ca3af",
              border: `1px solid ${vendor.isEnabled ? "#bbf7d0" : "#e5e7eb"}`,
              borderRadius: 6, padding: "1px 6px", textTransform: "uppercase", letterSpacing: "0.04em",
            }}>
              {vendor.isEnabled ? "Aktif" : "Pasif"}
            </span>
          </div>
          {vendor.note && <div style={{ fontSize: "0.78rem", color: "#6b7280", marginTop: 2 }}>{vendor.note}</div>}
        </div>
        <div style={{ display: "flex", gap: 6, flexShrink: 0 }}>
          <button onClick={() => setEditing(true)} title="Düzenle"
            style={{ background: "#fffbeb", border: "1px solid #fde68a", borderRadius: 7, width: 30, height: 30, display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", color: "#b45309" }}>
            <i className="bi bi-pencil" style={{ fontSize: "0.78rem" }} />
          </button>
          {confirmDel ? (
            <div style={{ display: "flex", gap: 4 }}>
              <button onClick={handleDelete} disabled={deleting}
                style={{ background: "#dc2626", border: "none", borderRadius: 7, padding: "0 10px", fontWeight: 700, fontSize: "0.72rem", color: "#fff", cursor: "pointer" }}>
                {deleting ? <span className="spinner-border spinner-border-sm" /> : "Sil"}
              </button>
              <button onClick={() => setConfirmDel(false)}
                style={{ background: "#f1f5f9", border: "1px solid #e5e7eb", borderRadius: 7, padding: "0 8px", fontWeight: 600, fontSize: "0.72rem", color: "#6b7280", cursor: "pointer" }}>
                İptal
              </button>
            </div>
          ) : (
            <button onClick={() => setConfirmDel(true)} title="Sil"
              style={{ background: "#fef2f2", border: "1px solid #fecaca", borderRadius: 7, width: 30, height: 30, display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", color: "#dc2626" }}>
              <i className="bi bi-trash3" style={{ fontSize: "0.78rem" }} />
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

export default function VendorManagerModal({ onClose, onChange }: Props) {
  const [vendors, setVendors] = useState<IExpenseVendor[]>([]);
  const [loading, setLoading] = useState(true);
  const [loadError, setLoadError] = useState<string | null>(null);

  const [showAdd, setShowAdd] = useState(false);
  const [form, setForm] = useState(EMPTY_FORM);
  const [addLoading, setAddLoading] = useState(false);
  const [addError, setAddError] = useState<string | null>(null);

  const [isNarrow, setIsNarrow] = useState(window.innerWidth < 640);
  useEffect(() => {
    const h = () => setIsNarrow(window.innerWidth < 640);
    window.addEventListener("resize", h);
    return () => window.removeEventListener("resize", h);
  }, []);

  const loadVendors = () => {
    setLoading(true);
    setLoadError(null);
    getExpenseVendors(true)
      .then((res) => setVendors(res.data ?? []))
      .catch(() => setLoadError("Firmalar yüklenemedi."))
      .finally(() => setLoading(false));
  };

  useEffect(() => { loadVendors(); }, []);

  const handleRefresh = () => { loadVendors(); onChange?.(); };

  const handleAddSubmit = async () => {
    if (!form.name.trim()) { setAddError("Firma adı zorunludur."); return; }
    setAddLoading(true);
    setAddError(null);
    try {
      await createExpenseVendor({ name: form.name.trim(), note: form.note.trim() });
      setForm(EMPTY_FORM);
      setShowAdd(false);
      handleRefresh();
    } catch {
      setAddError("Firma eklenemedi. Lütfen tekrar deneyin.");
    } finally {
      setAddLoading(false);
    }
  };

  const panelStyle: React.CSSProperties = isNarrow
    ? { position: "fixed", inset: 0, zIndex: 2050, background: "#fff", display: "flex", flexDirection: "column", overflow: "hidden" }
    : { position: "fixed", top: "50%", left: "50%", zIndex: 2050, transform: "translate(-50%,-50%)", width: "min(540px,calc(100vw - 24px))", maxHeight: "88dvh", background: "#fff", borderRadius: 20, boxShadow: "0 24px 64px rgba(0,0,0,0.18)", display: "flex", flexDirection: "column", overflow: "hidden" };

  const inp: React.CSSProperties = { width: "100%", borderRadius: 9, border: "1.5px solid #fde68a", padding: "9px 12px", fontSize: "0.86rem", color: "#111827", outline: "none", background: "#fff", fontFamily: "inherit", boxSizing: "border-box" };

  const activeCount = vendors.filter((v) => v.isEnabled).length;

  return (
    <>
      {!isNarrow && <div onClick={onClose} style={{ position: "fixed", inset: 0, zIndex: 2049, background: "rgba(0,0,0,0.5)", backdropFilter: "blur(4px)" }} />}

      <div style={panelStyle}>
        {/* Header */}
        <div style={{ padding: isNarrow ? "14px 16px" : "16px 20px", background: "linear-gradient(135deg,#92400e,#b45309)", display: "flex", alignItems: "center", gap: 12, flexShrink: 0 }}>
          <div style={{ width: 38, height: 38, borderRadius: 10, flexShrink: 0, background: "rgba(255,255,255,0.15)", display: "flex", alignItems: "center", justifyContent: "center" }}>
            <i className="bi bi-building text-white" style={{ fontSize: "1rem" }} />
          </div>
          <div style={{ flex: 1 }}>
            <div style={{ fontWeight: 800, fontSize: "0.96rem", color: "#fff" }}>Firmalar</div>
            <div style={{ fontSize: "0.66rem", color: "rgba(255,255,255,0.65)" }}>
              {loading ? "Yükleniyor…" : `${vendors.length} kayıt · ${activeCount} aktif`}
            </div>
          </div>
          <button onClick={onClose} style={{ background: "rgba(255,255,255,0.15)", border: "none", borderRadius: 9, width: 36, height: 36, display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", color: "#fff", fontSize: "0.9rem" }}>
            <i className="bi bi-x-lg" />
          </button>
        </div>

        {/* Body */}
        <div style={{ flex: 1, overflowY: "auto" }}>
          <div style={{ padding: isNarrow ? "14px" : "18px 20px", display: "flex", flexDirection: "column", gap: 12 }}>
            {loading && (
              <div style={{ display: "flex", justifyContent: "center", padding: "32px 0" }}>
                <span className="spinner-border" style={{ color: "#b45309" }} />
              </div>
            )}

            {loadError && (
              <div style={{ padding: "10px 14px", borderRadius: 10, background: "#fef2f2", border: "1.5px solid #fecaca", color: "#991b1b", fontSize: "0.82rem", display: "flex", alignItems: "center", gap: 8 }}>
                <i className="bi bi-exclamation-circle-fill" />
                {loadError}
                <button onClick={loadVendors} style={{ marginLeft: "auto", background: "none", border: "none", color: "#dc2626", cursor: "pointer", fontWeight: 700, fontSize: "0.78rem" }}>Tekrar dene</button>
              </div>
            )}

            {!loading && !loadError && vendors.length === 0 && (
              <div style={{ textAlign: "center", padding: "28px 0", color: "#9ca3af", fontSize: "0.84rem" }}>
                <i className="bi bi-building" style={{ fontSize: "2rem", display: "block", marginBottom: 8, color: "#d1d5db" }} />
                Henüz firma eklenmemiş
              </div>
            )}

            {vendors.map((v) => (
              <VendorCard key={v.id} vendor={v} onSaved={handleRefresh} onDeleted={handleRefresh} />
            ))}

            {/* Ayırıcı + Ekle */}
            <div style={{ display: "flex", alignItems: "center", gap: 10, marginTop: 4 }}>
              <div style={{ flex: 1, height: 1, background: "#f1f5f9" }} />
              <span style={{ fontSize: "0.68rem", fontWeight: 700, color: "#9ca3af", textTransform: "uppercase", letterSpacing: "0.05em" }}>Firma Ekle</span>
              <div style={{ flex: 1, height: 1, background: "#f1f5f9" }} />
            </div>

            {!showAdd ? (
              <button onClick={() => setShowAdd(true)}
                style={{ background: "linear-gradient(135deg,#b45309,#d97706)", border: "none", borderRadius: 10, padding: "10px 14px", fontWeight: 700, fontSize: "0.84rem", color: "#fff", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", gap: 7, boxShadow: "0 2px 10px rgba(180,83,9,0.3)" }}>
                <i className="bi bi-plus-lg" /> Yeni Firma Ekle
              </button>
            ) : (
              <div style={{ background: "#fffbeb", border: "1.5px solid #fde68a", borderRadius: 14, padding: "14px" }}>
                <div style={{ fontWeight: 700, fontSize: "0.82rem", color: "#92400e", marginBottom: 12, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  <span><i className="bi bi-building-add me-2" />Yeni Firma</span>
                  <button onClick={() => { setShowAdd(false); setForm(EMPTY_FORM); setAddError(null); }} style={{ background: "none", border: "none", cursor: "pointer", color: "#9ca3af", fontSize: "1rem" }}>
                    <i className="bi bi-x" />
                  </button>
                </div>
                <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
                  <div>
                    <label style={{ fontSize: "0.7rem", fontWeight: 700, color: "#92400e", textTransform: "uppercase", letterSpacing: "0.04em", display: "block", marginBottom: 4 }}>Firma Adı *</label>
                    <input value={form.name} onChange={(e) => setForm((p) => ({ ...p, name: e.target.value }))} placeholder="ör. Hostinger" style={inp} />
                  </div>
                  <div>
                    <label style={{ fontSize: "0.7rem", fontWeight: 700, color: "#92400e", textTransform: "uppercase", letterSpacing: "0.04em", display: "block", marginBottom: 4 }}>Not</label>
                    <input value={form.note} onChange={(e) => setForm((p) => ({ ...p, note: e.target.value }))} placeholder="ör. Hosting Firması (opsiyonel)" style={inp} />
                  </div>
                  {addError && (
                    <div style={{ padding: "8px 12px", borderRadius: 8, background: "#fef2f2", border: "1px solid #fecaca", color: "#991b1b", fontSize: "0.78rem" }}>
                      {addError}
                    </div>
                  )}
                  <button onClick={handleAddSubmit} disabled={addLoading || !form.name.trim()}
                    style={{
                      background: form.name.trim() && !addLoading ? "linear-gradient(135deg,#b45309,#d97706)" : "#e5e7eb",
                      border: "none", borderRadius: 10, padding: "10px 0",
                      fontWeight: 700, fontSize: "0.88rem",
                      color: form.name.trim() && !addLoading ? "#fff" : "#9ca3af",
                      cursor: form.name.trim() && !addLoading ? "pointer" : "default",
                      display: "flex", alignItems: "center", justifyContent: "center", gap: 7,
                    }}>
                    {addLoading ? <><span className="spinner-border spinner-border-sm" /> Ekleniyor…</> : <><i className="bi bi-check-lg" /> Firma Ekle</>}
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>

        {/* Footer */}
        <div style={{ padding: isNarrow ? "12px 16px" : "12px 20px", borderTop: "1.5px solid #f1f5f9", background: "#fafafa", display: "flex", justifyContent: "space-between", alignItems: "center", flexShrink: 0 }}>
          <button onClick={loadVendors} style={{ background: "none", border: "none", cursor: "pointer", color: "#6b7280", fontSize: "0.8rem", display: "flex", alignItems: "center", gap: 5, fontWeight: 600 }}>
            <i className="bi bi-arrow-clockwise" /> Yenile
          </button>
          <button onClick={onClose}
            style={{ background: "#fff", border: "1.5px solid #e5e7eb", borderRadius: 10, padding: isNarrow ? "10px 24px" : "7px 22px", fontWeight: 700, fontSize: "0.88rem", color: "#374151", cursor: "pointer", display: "flex", alignItems: "center", gap: 6 }}>
            <i className="bi bi-x-lg" /> Kapat
          </button>
        </div>
      </div>
    </>
  );
}
